import { Capacitor } from "@capacitor/core";

export function isNativeCapacitor(): boolean {
	return Capacitor.isNativePlatform();
}

export function isNativeIos(): boolean {
	return isNativeCapacitor() && Capacitor.getPlatform() === "ios";
}

export function getPlatformDiagnostics() {
	return {
		platform: Capacitor.getPlatform(),
		native: isNativeCapacitor(),
		nativeIos: isNativeIos(),
	};
}

export function isWebBrowser(): boolean {
	return !isNativeCapacitor();
}

export const NATIVE_IOS_ACCESS_COPY = {
	accountAccessHeader: "Account Access",
	accessEnabled: "Rider subscription access is active for this account.",
	accessUnavailable: "This feature is not available for your account.",
	accessManaged:
		"Access is managed through your FlaggerAI account. Contact support if you believe this is incorrect.",
	paymentUnavailable:
		"Payment methods are not available in the iOS app.",
	eventCheckoutNote:
		"Race signup is for real-world event participation and services provided at the track.",
};

export function canShowExternalSubscriptionPurchase(): boolean {
	return !isNativeIos();
}

export function canShowDigitalPlanPricing(): boolean {
	return !isNativeIos();
}

export function canShowSquareSubscriptionManagement(): boolean {
	return !isNativeIos();
}

export function canShowSquareCardManagement(): boolean {
	return !isNativeIos();
}

export interface NativeIosEventCheckoutItem {
	productType?: string;
	createsEntry?: boolean;
	nativeIosCheckoutAllowed?: boolean;
	consumedOutsideApp?: boolean;
	consumptionType?: string;
}

export function canUseNativeIosEventCheckoutItem(
	item: NativeIosEventCheckoutItem | null | undefined
): boolean {
	if (!isNativeIos()) {
		return true;
	}

	if (!item) {
		return false;
	}

	if (item.productType !== "addOn" && item.createsEntry !== false) {
		return true;
	}

	if (item.nativeIosCheckoutAllowed === true || item.consumedOutsideApp === true) {
		return true;
	}

	const consumptionType = `${item.consumptionType || ""}`.toLowerCase();
	return [
		"physical",
		"offline",
		"eventservice",
		"event-service",
		"race-day-service",
		"real-world",
	].includes(consumptionType);
}

export function canUseNativeIosEventCheckoutCart(
	items: Array<NativeIosEventCheckoutItem | null | undefined>
): boolean {
	if (!isNativeIos()) {
		return true;
	}

	return items.length > 0 && items.every(canUseNativeIosEventCheckoutItem);
}

export function supportsBrowserServiceWorker(): boolean {
	return (
		isWebBrowser() &&
		typeof navigator !== "undefined" &&
		"serviceWorker" in navigator &&
		!!navigator.serviceWorker
	);
}

export function supportsBrowserNotifications(): boolean {
	return (
		isWebBrowser() &&
		typeof window !== "undefined" &&
		"Notification" in window
	);
}
